export default __webpack_public_path__ + "static/media/board.6d55efef.svg";